import { render, staticRenderFns } from "./HeaderMenuHelp.vue?vue&type=template&id=28d52b38"
import script from "./HeaderMenuHelp.vue?vue&type=script&lang=js"
export * from "./HeaderMenuHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports